// eslint-disable-next-line import/prefer-default-export
export const getHistory = (state) => state.history.data;
